import React from "react";
import TBGallery from "../../../photoGallery/TBGallery";
import Image2 from "../../../../assets/gallery/currentProjects/ChrisCoelo/2.webp";
import Image3 from "../../../../assets/gallery/currentProjects/ChrisCoelo/3.webp";
import Image4 from "../../../../assets/gallery/currentProjects/ChrisCoelo/4.webp";
import Image5 from "../../../../assets/gallery/currentProjects/ChrisCoelo/5.webp";
import Image6 from "../../../../assets/gallery/currentProjects/ChrisCoelo/6.webp";
import Image7 from "../../../../assets/gallery/currentProjects/ChrisCoelo/7.webp";
import { ProjectDetails } from "./ProjectDetails";
import "../../projectStyling/style.css";
import Footer from "../../../Footer";

const ChrisCoelo = () => {
  const galleryImages = [
    {
      img: Image2,
    },
    {
      img: Image3,
    },
    {
      img: Image4,
    },
    {
      img: Image5,
    },
    {
      img: Image6,
    },
    {
      img: Image7,
    },
  ];
  return (
    <>
      <br />
      <div>
        <ProjectDetails />
      </div>
      <br />
      <div>
        <TBGallery galleryImages={galleryImages} />
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default ChrisCoelo;
